<template>
  <button type="button" class="btn-gray">
    <i v-if="icon" :class="icon" />
    <span v-if="icon" class="space-icon" />{{ label }}
  </button>
</template>

<script>
export default {
  name: "GrayButton",
  props: ["label", "icon"],
};
</script>
